import auth from './authentication'
import ui from './ui'

export default {
  auth,
  ui
}
